/** Atualiza dados sem remontar a página ou descartar entradas locais do formulário. */
import { RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

export function DataRefreshButton({ onRefresh, refreshing, className }: {
  onRefresh: () => void; refreshing: boolean; className?: string;
}) {
  return <Button type="button" size="icon" variant="ghost" onClick={onRefresh} disabled={refreshing}
    aria-label="Atualizar dados" title="Atualizar dados" className={cn('h-10 w-10 shrink-0', className)}>
    <RefreshCw className={cn('h-5 w-5', refreshing && 'animate-spin motion-reduce:animate-none')} />
  </Button>;
}